// Banks and credit unions operating in St. Kitts & Nevis.
// Mirrors iOS SKNBank (Models/SKNBank.swift) — payout details pickers use
// this list instead of free-form bank names. 'Other' shows a text input.
export const SKN_BANKS = [
  // Commercial banks
  'SKNA National Bank',
  'Bank of Nevis',
  'Republic Bank (EC)',
  'CIBC FirstCaribbean',
  'Hamilton Reserve Bank',
  'Development Bank of St. Kitts & Nevis',
  // Credit unions
  'St. Kitts Co-operative Credit Union',
  'Nevis Co-operative Credit Union',
  'Police Co-operative Credit Union',
  'First Federal Credit Union',
  'Other',
];

// True when `stored` is a known entry; unknown/free-form names -> 'Other'.
export function bankPickerValue(stored) {
  return SKN_BANKS.includes(stored) ? stored : 'Other';
}
